module.exports = __webpack_public_path__ + "img/444.354bfbbf.jpeg";